import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

export const Section = styled.section`
    padding: 0.5rem 0;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1.5rem;
    }
`
export const InnerContainer = styled.div`
    margin-top: 0.35rem;
    @media only screen and (max-width: ${tabletBreakpoint.max}px) {
        padding: 0 1rem;
    }
`

export const TitleContainer = styled.div(
    () => css`
        width: inherit;
        padding: 0.75rem 1rem 0.25rem;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 1rem 0 0.5rem;
        }
    `,
)

export const Title = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-size: 1.25rem;
        font-weight: 700;
        line-height: 1.62rem;
        color: ${theme.colors.tfwBlack99};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1.25rem;
            line-height: 2.5rem;
        }
        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 2rem;
        }
    `,
)
